module.exports = __webpack_public_path__ + "img/ZWT.1f43814b.png";